import { makeAutoObservable } from "mobx";

class ProductOrientationStore {
  selectedOrientationIndex: number | null = null;
  selectedOrientation: string = "";

  constructor() {
    makeAutoObservable(this);
  }

  // Action to set the selected orientation
  setSelectedOrientation(index: number, orientation: string) {
    this.selectedOrientationIndex = index;
    this.selectedOrientation = orientation;
  }

  // Getter to retrieve the selected orientation index
  get getSelectedOrientationIndex() {
    return this.selectedOrientationIndex;
  }

  // Getter to retrieve the selected orientation string
  get getSelectedOrientation() {
    return this.selectedOrientation;
  }
}

const productOrientationStore = new ProductOrientationStore();
export default productOrientationStore;
